export const serializeAEMCookieCollection =
  <T>(serializeItem: (item: T) => string, splitter = ';') =>
  (itemsCollection: T[] = []): string => {
    const result: string = encodeURIComponent(itemsCollection.map(serializeItem).join(splitter));
    return result;
  };

export type Options = { expires?: Date | string; path?: string; domain?: string };

export function setCookie(name: string, value: string, options: Options = {}) {
  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  const cookie = [];
  cookie.push(`${name}=${value}`);

  for (let optionKey in options) {
    let optionValue = options[optionKey as keyof Options];
    if (optionValue) {
      cookie.push(`${optionKey}=${optionValue}`);
    }
  }

  document.cookie = cookie.join(';');
}
